import { Select } from "antd";
import React from "react";
import styled from "styled-components";

import { academicYears, defaultAcademicYear } from "years";

import arrowDown from "assets/images/png/arrow_down.png";

const ViewSelect = ({ onChange, background, year }) => {
  const handleChange = (value) => {
    onChange && onChange(value);
  };
  const yearList = Object.fromEntries(
    academicYears.flatMap(({ ce, be }) => [
      [ce, be],
      [be, be],
    ])
  );

  return (
    <CustomSelect
      background={background}
      dropdownAlign={{ offset: [0, 0] }}
      getPopupContainer={(node) => node.parentNode}
      defaultValue={year != null ? yearList[year] : defaultAcademicYear.be}
      dropdownMatchSelectWidth={false}
      suffixIcon={<img src={arrowDown} alt="" />}
      options={academicYears.map(({ ce, be }) => ({
        value: ce,
        label: be,
      }))}
      onChange={handleChange}
      placeholder=""
    />
  );
};

export default ViewSelect;

const CustomSelect = styled(Select)`
  width: 168px;
  height: 53px;

  .ant-select-selector {
    border: 1px solid var(--secondary) !important;
    height: 53px !important;
    border-radius: 37px !important;
    font-family: "Noto Sans Thai" !important;
    font-size: 26px !important;
    font-weight: 700 !important;
    color: var(--black) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px !important;
    background-color: ${(props) =>
      props.background ? props.background : "#EA8B49"} !important;
    opacity: 85%;

    &:hover {
      color: var(--white);
    }
  }

  .ant-select-arrow {
    right: 24px !important;

    img {
      width: 24px;
      height: 14px;
    }
  }

  @media screen and (max-width: 414px) {
    height: 48px !important;

    .ant-select-selector {
      height: 48px !important;
      font-size: 20px !important;
    }

    .ant-select-item {
      font-size: 20px !important;
    }

    .ant-select-arrow {
      img {
        width: 20px !important;
        height: 12px !important;
      }
    }
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    height: 48px !important;

    .ant-select-selector {
      height: 48px !important;
      font-size: 16px !important;
    }

    .ant-select-item {
      font-size: 16px !important;
    }

    .ant-select-arrow {
      img {
        width: 20px !important;
        height: 12px !important;
      }
    }
  }

  .ant-select-selection-placeholder {
    padding-right: 32px !important;
    color: var(--black) !important;
  }

  .ant-select-item {
    align-items: center;
    font-size: 26px !important;
    font-weight: 700 !important;
    min-height: 55px !important;
    padding: 0 !important;
    color: var(--black) !important;

    &:hover {
      color: var(--secondary) !important;
    }
  }

  .ant-select-selection-item {
    color: var(--black) !important;
    font-family: "Noto Sans Thai" !important;
    font-size: 26px !important;
    font-weight: 700 !important;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: var(--primary) !important;
  }
`;
